import { defineComponent as _defineComponent } from 'vue'
import SingleSignOnApple from '@/components/onboarding/singleSignOn/SingleSignOnApple.vue'
import SingleSignOnFacebook from '@/components/onboarding/singleSignOn/SingleSignOnFacebook.vue'
import SingleSignOnGoogle from '@/components/onboarding/singleSignOn/SingleSignOnGoogle.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSignOnSection',
  props: {
    mode: null
  },
  setup(__props: any) {



return { __sfc: true,SingleSignOnApple, SingleSignOnFacebook, SingleSignOnGoogle }
}

})